import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./ReactCanvasJSChart";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import { getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getProviderCompletionStats} from "root/DataFunctions/ChartFns";
import { useNavigate } from "react-router-dom";

const DashboardPanelProviderCompletionStats = ({ panelStyle='panel-default', survey_type, title='Title', id }) =>
{
	const [ data, setData ] = useState ( { loading: true, data: [], dataPoints: []})

	const navigate = useNavigate() ;

	useEffect(() =>
	{
		getServerData() ;
	}, []);

	const onRowClick = ( submissionStatus ) =>
	{
			const url = "/reports/admin/" + submissionStatus + "/current";

			navigate(url);
	}

	const getServerData = () =>
	{
		getProviderCompletionStats('current', survey_type,(response) =>
		{
			const reportData = getDataFromResponse(response);

			const rec = reportData[0] ;

			const total = +(rec['total']) ;
			const done = +(rec['done']) ;
			const notdone = total - done ;

			const pcent_done = done === 0 ? 0 : ( done / total) * 100 ;
			const pcent_not_done = 100 - pcent_done ;

			const points = [
				{ y: pcent_not_done, total: total, num: notdone, label: "Not Done", cursor: 'pointer', click: ()=> {onRowClick("unsubmitted")} },
				{ y: pcent_done, total: total, num: done, label: "Done", cursor: 'pointer', click: ()=> {onRowClick("submitted")} },
			] ;

			setData({loading: false, dataPoints: points, data: reportData }) ;
		});
	}

	const toolTipContent = (e) =>
	{
		let str = "";
		let total;
		let str2, str3;

		const str1 = "<span style= \"color:" + e.entries[0].dataPoint.color + "\"> " + e.entries[0].dataPoint.label + "</span>: <strong>" + e.entries[0].dataPoint.num + " out of " + e.entries[0].dataPoint.total + "</strong><br/>";
		const pcent = (+e.entries[0].dataPoint.y ) ;
		str = str.concat(str1);

		str2 = "<span style = \"color:DodgerBlue;\"><strong>" + e.entries[0].dataPoint.label + "</strong></span><br/>";

		total = Math.round(pcent);

		str3 = "<span style = \"color:Tomato\">Percentage:</span><strong> " + total + "%</strong><br/>";

		return (str2.concat(str)).concat(str3);
	}

	const formPanel = () =>
	{
		const options = {
			animationEnabled: true,
			height: 400,
			backgroundColor: "#FAFBFD",
			theme: 'light1',
			toolTip: {
				shared: false,
				content: toolTipContent
			},
			title: {
				text: "",
				fontColor: '#333',
				fontSize: 18,
				fontWeight:'lighter',
				fontFamily: 'tahoma',
				padding: 20
			},
			data: [
				{
					type: "pie",
					startAngle: 240,
					yValueFormatString: "0",
					indexLabel: "{label} {y}%",
					dataPoints: data.dataPoints
				}
			] } ;

		return (
			<div className={'panel ' + panelStyle}>
				{ getPanelHeader({ title: title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartCareersAdvice' options={options} uniqueId={'canvas'+ id}/>
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelProviderCompletionStats;
